import { useState } from 'react';
import { product } from 'ui/services';
import { capitalizeText } from 'ui/helpers/utils';

const useProduct = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const getDataAutoComplete = async (text) => {
    try {
      setLoading(true);
      setError(null);
      const payload = {
        source: text,
      };

      // Generate OTP
      const res = await product.globalSearch(payload);

      // Open otp form modal when success generate otp
      if (res.status === 200) {
        return res.data;
      }
    } catch (err) {
      console.log(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getProductList = async (params?: any) => {
    try {
      setLoading(true);
      setError(null);

      const res = await product.getProduct(params);

      if (res.status === 200) {
        // Transform product list to capital text
        const formattedData = res.data.map((prod) => {
          const productName = capitalizeText(prod.name);

          return {
            ...prod,
            name: productName,
          };
        });

        setProductList(formattedData);
        return formattedData;
      }
    } catch (err) {
      console.log(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    error,
    loading,
    productList,
    getDataAutoComplete,
    getProductList,
  };
};

export default useProduct;
